import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

//types
import type { ErrorCustom } from '@/utils/client';
//Utils
import { get } from '@/utils/client';

//routes
import { BILLING_LINK } from '@/routes/apiEndpoints';

export type CheckoutLinkDataType = {
    customer_id: string;
    type: 'inline_checkout' | 'direct_payment';
};

type UseCheckoutLinkProps = {
    product_id: string;
    options?: SWRConfiguration<CheckoutLinkDataType, ErrorCustom>;
};

export type MutateCheckoutLink = KeyedMutator<CheckoutLinkDataType>;

export function useCheckoutLink({ product_id, options }: UseCheckoutLinkProps) {
    const {
        data,
        mutate: mutateCheckoutLink,
        error: checkoutLinkError,
        isLoading
    } = useSWR<CheckoutLinkDataType, ErrorCustom>(
        product_id ? [BILLING_LINK, product_id] : null,
        ([url]) => get(url, { product_id }).then((res) => res.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        checkoutLink: data,
        mutateCheckoutLink,
        checkoutLinkError,
        isLoading
    };
}
